export interface AgentCommand {
  command: string;
  label: string;
  description: string;
}

export const AGENT_COMMANDS: AgentCommand[] = [
  { command: 'schedule', label: '/schedule', description: 'Create a recurring task' },
];

export function filterAgentCommands(input: string): AgentCommand[] {
  if (!input.startsWith('/')) return [];
  const query = input.slice(1).toLowerCase();
  return AGENT_COMMANDS.filter((c) => c.command.startsWith(query));
}
